import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getBanners } from '../services/bannerService';
import { getProducts } from '../services/productService';
import ProductCard from '../components/ProductCard';
import { ProductCardSkeleton } from '../components/Skeleton';
import { FiArrowRight } from 'react-icons/fi';

const Home = () => {
  const [banners, setBanners] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [bannersData, productsData] = await Promise.all([
          getBanners(),
          getProducts({ featured: true, limit: 8 }),
        ]);
        setBanners(bannersData);
        setFeaturedProducts(productsData.products || []);
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  return (
    <div>
      {/* Hero Banner Slider */}
      {banners.length > 0 && (
        <div className="relative h-96 md:h-[500px] overflow-hidden">
          <div className="absolute inset-0">
            <img
              src={banners[0].image}
              alt={banners[0].title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40"></div>
          </div>
          <div className="relative max-w-7xl mx-auto px-4 h-full flex items-center">
            <div className="text-white">
              <h1 className="text-4xl md:text-6xl font-bold mb-4">{banners[0].title}</h1>
              <p className="text-xl md:text-2xl mb-6">{banners[0].subtitle}</p>
              <Link
                to={banners[0].link || '/products'}
                className="inline-flex items-center px-6 py-3 bg-primary text-white rounded-lg hover:bg-indigo-700 transition"
              >
                Shop Now <FiArrowRight className="ml-2" />
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Featured Products */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-3xl font-bold text-gray-800">Featured Products</h2>
          <Link
            to="/products"
            className="text-primary hover:text-indigo-700 flex items-center"
          >
            View All <FiArrowRight className="ml-2" />
          </Link>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[...Array(8)].map((_, i) => (
              <ProductCardSkeleton key={i} />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {featuredProducts.map((product) => (
              <ProductCard key={product._id} product={product} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;

